export interface Partner {
    img: string;
    name: string;
}

export const partners: Partner[] = [
    { img: "TORYS.png", name: "Torys" },
    { img: "TMU.png", name: "TMU" },
    { img: "TD.png", name: "TD" },
    { img: "SYED_LAW.png", name: "Syed Law" },
    { img: "SRJ.jpg", name: "SRJ" },
    { img: "Sajjad_Ebrahim.png", name: "Sajjad Ebrahim" },
    { img: "RBC.png", name: "RBC" },
    { img: "PwC.png", name: "PwC" },
    { img: "Pallett_Valo.png", name: "Pallett Valo" },
    { img: "NZF.png", name: "NZF" },
    { img: "Mohammad_Al_Zaibak.png", name: "Mohammad Al Zaib" },
    { img: "Moez_Kassam.png", name: "Moez Kassam" },
    { img: "Mishkat.png", name: "Mishkat" },
    { img: "McCarthy_Tetrault.png", name: "McCarthy Tétrault" },
    { img: "KPMG.png", name: "KPMG" },
    { img: "IRC.jpg", name: "IRC" },
    { img: "InfiniteInvSys.png", name: "InfiniteInSys" },
    { img: "IKE.png", name: "IKE" },
    { img: "Greenshield.png", name: "Greenshield" },
    { img: "Fasken.png", name: "Fasken" },
    { img: "Extendicare.png", name: "Extendicare" },
    { img: "Eric_Welaufer.png", name: "Eric Wallauer" },
    { img: "DrAdnan.png", name: "Dr Adnan" },
    { img: "DAVIES.png", name: "Davies" },
    { img: "CF.png", name: "CF" },
];
